import styled, { keyframes } from 'styled-components';
import { device } from '../../Constants/device';

export const StylesHome = styled.section``;
